var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_9263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66665 14.0054C9.17668 14.0055 9.66746 13.8107 10.0386 13.4608C10.4097 13.111 10.6332 12.6326 10.6633 12.1234L10.6666 12.0054V9.33878H12C12.4901 9.33885 12.9631 9.15899 13.3293 8.83332C13.6956 8.50765 13.9295 8.05885 13.9866 7.57211L13.9966 7.45678L14 7.33878L13.9866 7.20811L13.316 3.85344C13.062 2.77011 12.3146 1.98944 11.4426 2.00011L11.3333 2.00544H5.99998C5.83659 2.00548 5.6789 2.06552 5.55686 2.17417C5.43482 2.28281 5.35693 2.43249 5.33798 2.59477L5.33331 2.67211L5.33398 9.02944C5.33398 9.14646 5.36479 9.26142 5.4233 9.36277C5.48181 9.46411 5.56597 9.54826 5.66731 9.60677C5.95151 9.7709 6.19091 10.0025 6.36439 10.2811C6.53786 10.5596 6.64007 10.8767 6.66198 11.2041L6.66665 11.3388V12.0054C6.66665 12.5359 6.87736 13.0446 7.25243 13.4197C7.62751 13.7947 8.13621 14.0054 8.66665 14.0054Z",
    fill: "#D91E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 9.33871C3.4966 9.33868 3.6542 9.27873 3.77623 9.17023C3.89825 9.06172 3.97621 8.91221 3.99531 8.75004L3.99998 8.67204V2.67204C3.99996 2.50875 3.94001 2.35115 3.8315 2.22912C3.723 2.1071 3.57348 2.02914 3.41131 2.01004L3.33331 2.00537H2.66665C2.33005 2.00529 2.00587 2.13252 1.75919 2.36152C1.5125 2.59053 1.36155 2.90436 1.33665 3.24004L1.33331 3.34004V8.00671C1.33337 8.34297 1.46049 8.6668 1.6892 8.91331C1.91791 9.15983 2.23132 9.31082 2.56665 9.33604L2.66665 9.33937L3.33331 9.33871Z",
    fill: "#D91E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_9263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.24327470.svg";
export { ForwardRef as ReactComponent };